import Vue from 'vue';
import MetalCalculator from './components/MetalCalculator.vue';

// Function to mount calculator on elements
function mountMetalCalculators() {
  // Find all metal calculator mount points that haven't been initialized
  const mountElements = document.querySelectorAll('.metal-calculator-mount:not([data-v-app])');

  mountElements.forEach((mountEl) => {
    // Mark as initialized to prevent double-mounting
    mountEl.setAttribute('data-v-app', 'true');
    
    const configData = mountEl.getAttribute('data-returpose-config');
    const mode = mountEl.getAttribute('data-mode') || 'full';
    // Position among all calculators on the page, used to find the form that started a Telia verification
    const instanceIndex = Array.from(document.querySelectorAll('.metal-calculator-mount, .metal-calculator-shortcode')).indexOf(mountEl);
    let parsedData = null;

    if (configData) {
      try {
        parsedData = JSON.parse(configData);
      } catch (e) {
        console.error('Failed to parse returpose config:', e);
      }
    }

    new Vue({
      render: h => h(MetalCalculator, {
        props: {
          returposeConfig: parsedData,
          initialTexts: parsedData ? parsedData.texts : null,
          mode: mode,
          instanceIndex: instanceIndex
        } 
      }),
    }).$mount(mountEl);
  });
}

// Mount on initial page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountMetalCalculators);
} else {
  mountMetalCalculators();
}

// Support for Elementor frontend dynamic loading
if (window.jQuery) {
  window.jQuery(window).on('elementor/frontend/init', function() {
    if (window.elementorFrontend && window.elementorFrontend.hooks) {
      window.elementorFrontend.hooks.addAction('frontend/element_ready/ka_metal_calculator.default', function() {
        mountMetalCalculators();
      });
    }
  });
}

// Also observe DOM for dynamically added calculators (fallback)
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(function(mutations) {
    let shouldMount = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.classList?.contains('metal-calculator-mount') || node.querySelector?.('.metal-calculator-mount'))) {
            shouldMount = true;
          }
        });
      }
    });
    if (shouldMount) {
      mountMetalCalculators();
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
}